export const NOT_IN_DELIVERY_REGION = 10
export const PRODUCTS_NOT_AVAILABLE = 20
export const NO_AVAILABLE_SLOT = 30
export const MINIMUM_VALUE_NOT_REACHED = 40

export const RX_NOT_AVAILABLE = 999
